import React from 'react'

import { Colors } from '@utils/Colors'
import { formatCurrency } from '@utils/masks'
import { ColorWrapper, TextParagraph } from '@atoms'
import { Contrato } from '@store/refinanciamento/contratos/types'

import { LabelDiv } from './styles'

interface ValorParcelaProps {
  contrato: Contrato
  isDisabled: boolean
}

const ValorParcela = ({
  contrato,
  isDisabled,
}: ValorParcelaProps & React.HTMLAttributes<HTMLDivElement>) => {
  const color = isDisabled ? '#' : Colors.GRAY500

  return (
    <LabelDiv>
      <ColorWrapper color={color} fontWeight="600">
        <TextParagraph variant="body-3" margin="0px 0px 4px 0px" fontWeight="600">
          Valor da parcela
        </TextParagraph>
      </ColorWrapper>
      <ColorWrapper color={color}>
        <TextParagraph variant="body-3" margin="0px 0px 8px 0px">
          {formatCurrency(contrato.valorProximaParcela)}
        </TextParagraph>
      </ColorWrapper>
      <ColorWrapper color={isDisabled ? '#' : Colors.GRAY400} margin="0" />
    </LabelDiv>
  )
}

export default ValorParcela
